module.exports = __webpack_public_path__ + "img/Dominican-Republic.08d4f549.png";